<template>
        <article class="info-section elr-container-full">
            <div class="elr-row">
                <div class="elr-col-full">
                    <div class="info-section-header">
                        <notification :notification="notification" @dismissAlert="dismiss"></notification>
                        <h1 class="info-section-heading">{{heading}}</h1>
                        <p>{{description}}</p>
                    </div>
                </div>
            </div>
            <div class="elr-row">
                <div class="elr-col-full">
                    <ul class="wishlist-list">
                        <li :key="wishlist.id" v-for="wishlist in wishlists">
                            <router-link :to="`/wishlist/${wishlist.username}`">{{wishlist.name}}</router-link> - {{wishlist.visibility}} - {{wishlist.username}} - {{wishlist.item_count}} {{(wishlist.item_count == 1) ? 'item' : 'items'}}
                        </li>
                    </ul>
                    <pagination v-if="pagination.pageCount > 1" @paginate="fetchWishLists" :pagination="pagination"></pagination>
                </div>
            </div>
        </article>
</template>

<script>
import axios from 'axios';
import Pagination from '../../components/Pagination/Pagination';
import Notification from '../../components/Notification/Notification';

export default {
  name: 'WishListList',
  data() {
    return {
      wishlists: [],
      heading: '',
      description: '',
      pagination: {},
      notification: {
        show: false,
        className: '',
        message: ''
      }
    };
  },
  components: {
    Notification,
    Pagination
  },
  mounted() {
    axios.get(`/wishlists`).then(({ data }) => {
      this.heading = data.heading;
      this.description = data.description;
      this.wishlists = data.wishlists.data;
      this.pagination = {
        prevUrl: data.wishlists.prev_page_url,
        nextUrl: data.wishlists.next_page_url,
        current: data.wishlists.current_page,
        total: data.wishlists.total,
        path: data.wishlists.path,
        pageCount: data.wishlists.last_page,
        firstUrl: `${data.wishlists.path}?page=1`,
        lastUrl: `${data.wishlists.path}?page=${data.wishlists.last_page}`
      };
    });
  },
  methods: {
    dismiss() {
      this.notification.show = false;
    },
    fetchWishLists(payload) {
      let url = payload;

      axios.get(url).then(({ data }) => {
        this.wishlists = data.wishlists.data;
        this.pagination.prevUrl = data.wishlists.prev_page_url;
        this.pagination.nextUrl = data.wishlists.next_page_url;
        this.pagination.current = data.wishlists.current_page;
      });
    }
  }
};
</script>
